import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
export interface UserOptions {
	[key: string]: unknown;
}

@Injectable({
	providedIn: 'root',
})
export class MonitoringService {
	public captureError(error: unknown, tags?: { [key: string]: unknown }): void {
		datadogRum.addError(error, tags);
	}

	public captureAction(
		action: string,
		tags?: { [key: string]: unknown }
	): void {
		datadogRum.addAction(action, tags);
	}

	public addViewName(viewName: string, service: string): void {
		datadogRum.startView({
			name: viewName,
			service: service,
		});
	}
	public setUser(user: UserOptions) {
		datadogRum.setUser(user);
	}
}
